import ResidentsTableEmptyMessage from "./ResidentsTableEmptyMessage";

export default ResidentsTableEmptyMessage;